import Vue from 'vue';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import {
  required,
  email,
  min,
  max,
  numeric,
  alpha,
  alpha_num as alphaNum,
} from 'vee-validate/dist/rules';

const rules = {
  required,
  email,
  min,
  max,
  numeric,
  alpha,
  alpha_num: alphaNum,
};

Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule as keyof typeof rules]);
});

extend('array_required', {
  validate: (value) => Array.isArray(value) && value.length > 0,
  message: '{_field_} is required',
});

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
